/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from 'ethers'
import type { Provider } from '@ethersproject/providers'
import type { IStableSwapMigratorContract, IStableSwapMigratorContractInterface } from '../IStableSwapMigratorContract'

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'fromAmountLp',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'fromAmount0',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'fromAmount1',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'toAmountLp',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'toAmount0',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'toAmount1',
        type: 'uint256',
      },
    ],
    name: 'Migrate',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'fromStakingService',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'toStakingService',
        type: 'address',
      },
      {
        components: [
          {
            internalType: 'uint128',
            name: 'unstakeSignedAmount',
            type: 'uint128',
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256',
          },
          {
            internalType: 'uint8',
            name: 'unstakeV',
            type: 'uint8',
          },
          {
            internalType: 'bytes32',
            name: 'unstakeR',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'unstakeS',
            type: 'bytes32',
          },
          {
            internalType: 'uint128',
            name: 'claimSignedAmount',
            type: 'uint128',
          },
          {
            internalType: 'uint8',
            name: 'claimV',
            type: 'uint8',
          },
          {
            internalType: 'bytes32',
            name: 'claimR',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'claimS',
            type: 'bytes32',
          },
        ],
        internalType: 'struct StableswapMigrator.MigratePayload',
        name: 'payload',
        type: 'tuple',
      },
    ],
    name: 'migrate',
    outputs: [
      {
        internalType: 'uint256',
        name: 'amount0Refund',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'amount1Refund',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const

export class IStableSwapMigratorContract__factory {
  static readonly abi = _abi
  static createInterface(): IStableSwapMigratorContractInterface {
    return new utils.Interface(_abi) as IStableSwapMigratorContractInterface
  }
  static connect(address: string, signerOrProvider: Signer | Provider): IStableSwapMigratorContract {
    return new Contract(address, _abi, signerOrProvider) as IStableSwapMigratorContract
  }
}
